import { Provider } from './providerClass';

export class Physician extends Provider {
    
    entityTypeClassName = 'Physician'
    
    constructor(data) {
        super(data);
    }
}